import React from 'react';
import Partners from './Partners';
import ParentLayout from './ParentLayout';

export default function Layout(props) {
  return (
    <ParentLayout title="Partners">
      {function(params) {
        return (
          <>
            <Partners params={params} />
          </>
        );
      }}
    </ParentLayout>
  );
}
